import api from './api';

const scheduledImportService = {
  // Obtenir toutes les importations planifiÃ©es
  getScheduledImports: async () => {
    try {
      const response = await api.get('/scheduled-imports');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Erreur lors de la rÃ©cupÃ©ration des importations planifiÃ©es');
    }
  },

  // Obtenir une importation planifiÃ©e spÃ©cifique
  getScheduledImport: async (id) => {
    try {
      const response = await api.get(`/scheduled-imports/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Erreur lors de la rÃ©cupÃ©ration de l\'importation planifiÃ©e');
    }
  },

  // CrÃ©er une nouvelle importation planifiÃ©e
  createScheduledImport: async (data) => {
    try {
      const response = await api.post('/scheduled-imports', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Erreur lors de la crÃ©ation de l\'importation planifiÃ©e');
    }
  },

  // Mettre Ã  jour une importation planifiÃ©e
  updateScheduledImport: async (id, data) => {
    try {
      const response = await api.put(`/scheduled-imports/${id}`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Erreur lors de la mise Ã  jour de l\'importation planifiÃ©e');
    }
  },

  // Supprimer une importation planifiÃ©e
  deleteScheduledImport: async (id) => {
    try {
      const response = await api.delete(`/scheduled-imports/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Erreur lors de la suppression de l\'importation planifiÃ©e');
    }
  },

  // ExÃ©cuter une importation planifiÃ©e immÃ©diatement
  runScheduledImport: async (id) => {
    try {
      const response = await api.post(`/scheduled-imports/${id}/run`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Erreur lors de l\'exÃ©cution de l\'importation planifiÃ©e');
    }
  },

  // NOUVELLE FONCTION : Valider un fichier Google Drive
  validateGoogleDriveFile: async (fileId) => {
    try {
      const response = await api.post('/scheduled-imports/validate-google-drive', { fileId });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Erreur lors de la validation du fichier Google Drive');
    }
  }
};

export default scheduledImportService;
